import CONSTANTS from '../../../constants'
import { PublisherArticleRSS } from '../hooks/usePublisherInfo'

export const RSSUrlBuilder = (publisherData: PublisherArticleRSS | null) => {
  const { API_BASE_URL } = CONSTANTS

  if (publisherData === null) return []

  const rssUrl = `${API_BASE_URL}/feeds/articles/${publisherData.type}/${publisherData.code}/${publisherData.hash}.rss`
  const atomUrl = `${API_BASE_URL}/feeds/articles/${publisherData.type}/${publisherData.code}/${publisherData.hash}.atom`

  return [rssUrl, atomUrl]
}
